import useAuth from "../../../Redux/useAuth";
import { CloseIconModelWindow } from "../Icons/Icons";
import { AvatarModel, ButtonClose, ContainerAvatarUser } from "./AvatarUserViewStyles.styled";

interface ModelAvatarProps {
  onClose: () => void;
  newAvatarUser?: string;
}

export const AvatarUserViewModel: React.FC<ModelAvatarProps> = ({newAvatarUser, onClose }) => {
  const { user } = useAuth();
  return (
    <>
      <ContainerAvatarUser>
        <ButtonClose onClick={onClose}>
          <CloseIconModelWindow />
        </ButtonClose>
        <AvatarModel
          crossOrigin='anonymous'
          src={newAvatarUser}
          alt={`${user?.name}'s avatar`} />
      </ContainerAvatarUser>
      
    </>
  );
};
